import { usePermission } from '../../hooks/usePermission';
import { Box, Typography, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

export function PermissionGate({ permission, module: moduleName, any, children, fallback }) {
  const { hasPermission, hasModuleAccess, hasAnyPermission } = usePermission();

  let allowed = false;

  if (any && Array.isArray(any)) {
    allowed = hasAnyPermission(...any);
  } else if (permission) {
    allowed = hasPermission(permission);
  } else if (moduleName) {
    allowed = hasModuleAccess(moduleName);
  } else {
    allowed = true;
  }

  if (allowed) return children;

  if (fallback) return fallback;

  return null;
}

export function PermissionDeniedPage() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <Paper sx={{ p: 6, textAlign: 'center', maxWidth: 460, borderRadius: 3 }}>
        <LockOutlinedIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
          Access Denied
        </Typography>
        <Typography color="text.secondary">
          You do not have permission to access this page. Please contact your administrator to request access.
        </Typography>
      </Paper>
    </Box>
  );
}

export function ProtectedRoute({ permission, module: moduleName, any, children }) {
  const { hasPermission, hasModuleAccess, hasAnyPermission } = usePermission();

  let allowed = false;

  if (any && Array.isArray(any)) {
    allowed = hasAnyPermission(...any);
  } else if (permission) {
    allowed = hasPermission(permission);
  } else if (moduleName) {
    allowed = hasModuleAccess(moduleName);
  } else {
    allowed = true;
  }

  if (allowed) return children;
  return <PermissionDeniedPage />;
}
